import React, { Component } from 'react';
import { Platform, StyleSheet, Text, View, StatusBar } from 'react-native';

/*
One day this will be a nice animation of the CalCal logo exploding...

*/

export default class Splash extends Component {
	render() {
		return (
			<View style={styles.container}>
				<StatusBar barStyle="light-content" backgroundColor="#438eb9" />
				<Text style={styles.welcome}>Welcome!</Text>

				{!this.props.signedIn && <Text style={styles.instructions}>Signing In....</Text>}
			</View>
		);
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: '#438eb9'
	},
	welcome: {
		fontSize: 20,
		textAlign: 'center',
		margin: 10,
		color: '#a1c7dd'
	},
	instructions: {
		textAlign: 'center',
		color: '#F5FCFF',
		marginBottom: 5
	}
});
